import * as React from 'react';

import { PORTRAIT_MEDIA_QUERY } from '../constants';

const subscribe = (callback: () => void) => {
  const mediaQueryList = window.matchMedia(PORTRAIT_MEDIA_QUERY);
  mediaQueryList.addEventListener('change', callback);

  return () => mediaQueryList.removeEventListener('change', callback);
};

const getSnapshot = () => window.matchMedia(PORTRAIT_MEDIA_QUERY).matches;

const getServerSnapshot = () => false;

/** Возвращает, находится ли экран в портретной ориентации, и следит за её сменой */
export const useIsPortrait = () => React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
